<template>
  <div>
    <div class="reporting-filters p-10 p-b-0">
      <ValidationObserver
        ref="formValidation"
        v-slot="{ invalid }"
        slim
      >
        <form
          name="reportingFilters"
        >
          <FilterCriteria
            v-if="!showSummary"
            v-model="filterCriteriaCopy"
            is-full-width
            :available-tags="availableFilters"
            use-in-reporting-filters
            :values-for-reporting-filter="valuesForFilter"
            :form-name-for-user-settings="formNameForUserSettings"
            :event-category="eventCategory"
            :quick-filters="quickFilters"
          />
        </form>

        <FilterCriteriaConciseSummary 
          v-if="showSummary"
          :filter-criteria="filterCriteriaCopy"
          :available-tags="availableFilters"
          class="clickable"
          :tag-id-to-text="tagIdToText"
          @click="toggleSummary"
          @deleteOrCriteria="deleteOrCriteria"
        />

        <div 
          v-if="!isFilterCriteriaEmpty"
          :class="{'m-t-5': showSummary, 'm-t-15': !showSummary}"
          class="clearfix p-b-10"
        >
          <btn
            v-if="!showSummary"
            v-t="'APPLY_FILTERS'"
            type="success"
            size="sm"
            :disabled="invalid"
            @click="applyFilters"
          />

          <btn
            v-if="showSummary"
            v-t="'EDIT_FILTERS'"
            type="primary"
            size="sm"
            @click="toggleSummary"
          />

          <btn
            v-t="'CLEAR_FILTERS'"
            type="danger"
            size="sm"
            class="m-l-10"
            @click="clearFilters"
          />
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { tagIdToText } from '@/core/filters/tagIdToText';
import messages from './locales';
import FilterCriteria from '@/core/components/FilterCriteria/FilterCriteria';
import FilterCriteriaConciseSummary from '@/core/components/FilterCriteria/FilterCriteriaConciseSummary/FilterCriteriaConciseSummary';
import {
  valuesForFilters as mockValuesForFilters
} from '@/mock/mock-reporting-filter-data';

export default {
  name: 'ReportingFilter',
  components: {
    FilterCriteria,
    FilterCriteriaConciseSummary
  },
  props: {
    filterCriteria: {
      type: Array,
      default() {
        return [];
      }
    },
    availableFilters: {
      type: Array,
      default() {
        return [];
      }
    },
    quickFilters: {
      type: Array,
      default() {
        return [];
      }
    },
    valuesForFilter: {
      type: Object,
      default() {
        return {...mockValuesForFilters};
      }
    },
    formNameForUserSettings: {
      type: String,
      default: ''
    },
    eventCategory: {
      type: String,
      default: 'reporting-filter'
    }
  },
  data() {
    return {
      showSummary: false,
      filterCriteriaCopy: []
    };
  },
  computed: {
    isFilterCriteriaEmpty() {
      return this.filterCriteria.length === 0 && this.filterCriteriaCopy.length === 0;
    }
  },

  watch: {
    filterCriteria: {
      immediate: true,
      handler(newValue) {
        this.showSummary = newValue && newValue.length;
        this.filterCriteriaCopy = [...newValue];
      }
    }
  },
  created() {
    window.addEventListener('keypress', this.handleEnterKeyUp);
  },
  destroyed() {
    window.removeEventListener('keypress', this.handleEnterKeyUp);
  },
  methods: {
    toggleSummary() {
      this.showSummary = !this.showSummary;
    },
    applyFilters() {
      if(this.$refs.formValidation?.flags?.invalid === false) {
        this.showSummary = true;
        this.$emit('applyFilters', this.filterCriteriaCopy);
      }
    },
    clearFilters() {
      this.showSummary = false;
      this.filterCriteriaCopy = [];
      this.$emit('clearFilters', []);
    },
    deleteOrCriteria(orIndex, andIndex) {
      const andCriteria = this.filterCriteriaCopy[andIndex];
      if (andCriteria) {
        const orCriteria = andCriteria.tagCriteria[orIndex];
        if (orCriteria) {
          andCriteria.tagCriteria.splice(orIndex, 1);
          if (andCriteria.tagCriteria.length === 0) {
            this.filterCriteriaCopy.splice(andIndex, 1);
          }
          this.applyFilters();
        }
      }
    },
    handleEnterKeyUp(event) {
      if (event.isComposing || event.keyCode !== 13 ) {
        return;
      }
      this.applyFilters();
    },
    tagIdToText: tagIdToText
  },
  i18n: {
    locale: 'en',
    messages
  }
};
</script>

<style lang="scss" scoped>
.reporting-filters {
  background: var(--component-widget-panel__header-bg);
}
</style>